import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  companyName: "",
  directorList: [],
};

const companySlice = createSlice({
  name: "companyDetails",
  initialState,
  reducers: {
    setCompanyName: (state, action) => {
      const companyName = action.payload || {};

      state.companyName = companyName || state.companyName;
    },
    setNewDirector: (state, action) => {
      const newDirector = action.payload;
      state.directorList.push(newDirector);
    },
    setAllDirectors: (state, action) => {
      const allDirectors = action.payload; //array of directors
      state.directorList = allDirectors;
    },
  },
});

export const { setCompanyName, setNewDirector, setAllDirectors } =
  companySlice.actions;
export default companySlice.reducer;
